import React, { Component } from 'react'

import Button from 'components/Button'
import BarPage from 'components/Layout/BarPage'
import CtaTopRight from 'components/CtaTopRight'
import LoginForm from '../LoginForm'

import cn from 'classnames'
import s from './Login.scss'
import sLay from 'styles/modules/layout.scss'

export default class Login extends Component {
  render() {
    const { push } = this.props

    return (
      <BarPage title="Pickle. Calls and Internet. Made Simple.">
        <CtaTopRight text="Don't have an account?">
          <Button to="/join" plain size="sm" className={sLay['hide-gt-xs']}>
            Sign up
          </Button>
          <Button to="/join" ghost color="tertiary" size="sm" className={sLay['hide-xs']}>
            Sign up
          </Button>
        </CtaTopRight>
        <div
          className={cn(
            s.content,
            sLay['layout-column'],
            sLay.flex,
            sLay['layout-align-center-center']
          )}
        >
          <LoginForm prev={() => push('/')} onAfterSubmit={() => push('/dashboard')} />
        </div>
      </BarPage>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/Login/Login.jsx